import { whatsappUrl } from "@/mocks/serra";

export default function WhatsAppButton() {
  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="nofollow noopener noreferrer"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-6 right-6 z-[60] w-14 h-14 flex items-center justify-center rounded-full bg-green text-bg text-2xl shadow-lg shadow-black/30 transition-transform duration-300 hover:scale-110"
    >
      <span className="absolute inset-0 rounded-full bg-green animate-ping opacity-40"></span>
      <i className="ri-whatsapp-fill relative"></i>
    </a>
  );
}
